import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    flex: 1;
    width: 100%;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    width: 100%;
`;
